import 'intersection-observer'
import scrollama from 'scrollama'
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

var site = {
	bootstrap: () => {
		console.log('custom js loaded')
		site.oldnavMenu()		
		site.scrollAnim()
		site.scrollChange()		
		site.derSlider()
		// site.slider()
		// site.scrollPosition()
		// site.scrolltop()
		// site.initMenu()
		// site.initResponsiveMenu()
		// site.navScroll()
		// site.triggerVisible()
		// site.slideSelection('door')
		// site.slideSelection('project')
		// site.setStartClippath()
		// site.initNavToggle()


		window.addEventListener('resize', () => {
			// site.slider()
			// site.setStartClippath()
			// site.slideSelectionDetailsHeight('door')
		} )
	},

	// scrollPosition: () => {	

	// 	var myScrollFunc = function () {	
	// 		var y = window.scrollY;
			
	// 		if (y >= 500) {
	// 			document.getElementById("toTop").classList.remove("hidden");
	// 		} else {
	// 			document.getElementById("toTop").classList.add("hidden");
	// 		}
	// 	};

	// 	window.addEventListener("scroll", myScrollFunc);

	// },

	
	// scrolltop: () => {	

	// 	window.addEventListener("load", function(){			

	// 		document.getElementById("toTop").onclick = function(){
				
	// 			window.scroll({
	// 				top: 0, 
	// 				left: 0, 
	// 				behavior: 'smooth'
	// 			});	
	// 		};
	//    });


		
	// },

	/*
	* Übertrag Altseite
	*/

	oldnavMenu: function() {
		$('nav#menu').mmenu();
	},

	scrollAnim: function() {

		$(window).scroll( function(){
    
			/* Check the location of each desired element */
			$('.hideme').each( function(i){
				
				var bottom_of_object = $(this).position().top + $(this).outerHeight() / 3;/*here is the change*/
				var bottom_of_window = $(window).scrollTop() + $(window).height();
	
	
				if( bottom_of_window > ( bottom_of_object + 20 )  ){
	
					$(this).removeClass('hide').animate({'opacity':'1'},500);
						
				}
				
			}); 
		
		});

	},

	scrollChange: function() {
		//Menu ScrollChange
		$(window).scroll(function() {
			//After scrolling 100px from the top...
			if ( $(window).scrollTop() >= 300 ) {
				$('.header-inner').css('position', 'fixed');
				$('.header-inner').css('top', '0');
				$('.header-inner').css('background', '#008a57');
				$('.header-inner').css('width', '100%');
				$('.header-inner').css('padding', '1%');
			//Otherwise remove inline styles and thereby revert to original stying
			} else {
				$('.header-inner').attr('style', '');

			}
		});
	},

	derSlider: function() {
		
		
		$(document).ready(function(){

			$('.slider').bxSlider({
				randomStart: true,
				minSlides: 1,
				maxSlides: 1,
				slideMargin: 10,
				auto:true			
			});
		});
	},

	/*
	* Funktionalität Desktop Menü
	*/

	initMenu: function() {
		
		$('#nav-main-menu li.dropdown').hover(
			
			function() {					
				$('ul', this).addClass('show');
			},
			function() {
				$('ul', this).removeClass('show');
			}
		);
		

		$(window).on('scroll', function () {
			var scrollTop = $(window).scrollTop();
			if (scrollTop > 100) {
				$('body').addClass('scrollpadding');
				$('header').addClass('fixingheader');
			}
			else {
				$('body').removeClass('scrollpadding');
				$('header').removeClass('fixingheader'); 

			}
		});
	},

	/**
	 * FUNKTIONALITÄT MOBILE MENU
	 */

	initResponsiveMenu: function() {

		/* FUNKTION ZUM ÖFFNEN DES MENÜS */

		function check_mobile_open() {

			if ($(window).width() < 1280) {					

				if ($("#hamburg").is(':checked')) {

					$( "#mobile" ).animate ({
						width: "100%",
						right: "0px"
					}, 1000, function() {
						$( "body" ).addClass("mobilenav");
					});

				} else {

					$( "#mobile" ).animate ({
						width: "100%",
						right: "-100%"
					}, 1000, function() {
						$( "body" ).removeClass("mobilenav");
					});
				}
			}
		}

		/* SOLLTE SEITE MIT OFFENEM MENÜ GELADEN WERDEN */

		check_mobile_open();
		
		/* MENÜ ÖFFNUNGSSTATUS DURCH KLICK ÄNDERN */

		$( "#hamburg" ).click(function() {

			check_mobile_open();

		});

		// 	$(this).toggleClass("is-active");
		// 	$(".navbar").toggleClass("navdarken");
		// 	$(".navbar .menu-item-has-children ul").toggleClass("show");
		// 	$(".content-area").toggleClass("darken");
		// 	$(".footer-overlay").toggleClass("darken");

		// });


		// $(".navbar #nav-main-menu li").click(function(e){
		// 	var url = $(this).children("a:first")[0].getAttribute("href");
		// 	document.location = url;
		// });

		// $(".navbar #nav-main-menu .menu-item-has-children").mouseenter(function(e){

		// 	if ( $("#nav-main-menu").hasClass("show") ) {
		// 		return;
		// 	}

		// 	$(this).addClass("show");
		// 	$(this).children("ul").addClass("show");
		// 	$(".content-area").addClass("darken");
		// 	$(".footer-overlay").addClass("darken");
		// 	e.preventDefault();
		// });

		// $(".navbar #nav-main-menu .menu-item-has-children").mouseleave(function(e){

		// 	if ( $("#nav-main-menu").hasClass("show") ) {
		// 		return;
		// 	}

		// 	$(this).removeClass("show");
		// 	$(this).children("ul").removeClass("show");
		// 	$(".content-area").removeClass("darken");
		// 	$(".footer-overlay").removeClass("darken");
		// 	e.preventDefault();
		// });

		// $(".navdarken #nav-main-menu .menu-item-has-children").click(function(e){
		// 	$(this).toggleClass("show");
		// 	$(this).children("ul").toggleClass("show");
		// 	$(".content-area").toggleClass("darken");
		// 	$(".footer-overlay").toggleClass("darken");
		// 	e.preventDefault();
		// });


		// $(".navdarken #nav-main-menu li").mouseenter(function(e){
		// 	return false;
		// });

		// $(".navdarken #nav-main-menu li").mouseleave(function(e){
		// 	return false;
		// });

	},

	slider: () => {

		Swiper.use([Navigation, Pagination]);
		const swiper = new Swiper('#teaser', {
			direction: 'horizontal',
			loop: true,
			// If we need pagination
			// pagination: {
			// 	el: '.swiper-pagination',
			// },

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			effect: 'fade',
		});


	},
	slideSelection: (target) => {
		const images = document.querySelectorAll('.' + target + '-image')
		for (const image of images) {
			image.addEventListener('click', function (e) {
				e.preventDefault()
				site.slideTrigger(this, target)
			})
		}
		site.slideSelectionDetailsHeight(target)
	},
	// Setze Höhe für Slider
	slideSelectionDetailsHeight: (target) => {
		const details = document.querySelectorAll('.' + target + '-details')
		let maxHeight = 0
		for (const detail of details) {
			maxHeight = Math.max( detail.scrollHeight, maxHeight )
		}

		document.querySelector("." + target + "-container").style.height = maxHeight + "px"
	},
	slideTrigger: function (element, target) {
		const images = document.querySelectorAll('.' + target + '-image')
		const details = document.querySelectorAll('.' + target + '-details')
		const id = element.getAttribute('data-' + target)

		for (const image of images) {
			image.classList.remove(target + '-image--active')
		}

		const activeClasses = [
			'xyz-in',
			'z-10',
			'max-h-[500px]',
			target + '-details--active'
		]

		for (const detail of details) {
			detail.classList.remove(...activeClasses)
			detail.classList.add('xyz-out', 'max-h-0')
			if (detail.classList.contains(target + '-' + id)) {
				detail.classList.add(...activeClasses)
				detail.classList.remove('xyz-out', 'max-h-0')
			}
		}

		element.classList.add(target  + '-image--active')
	},
	navScroll: () => {
		const links = document.querySelectorAll('.scrollto')

		for (const link of links) {
			link.addEventListener('click', site.handleScroll)
		}
	},
	handleScroll: function (e) {
		e.preventDefault()

		let element = document.querySelector(this.getAttribute('href'))
		let offsetTop = 0

		// if the parent has a defined position like relative, offsetTop
		// gets the distance to that element, not the page. so we have to
		// get the parents offset as well.
		while (element) {
			offsetTop += element.offsetTop
			element = element.offsetParent
		}

		scroll({
			top: offsetTop - 80,
			behavior: 'smooth'
		})
	},
	triggerVisible: () => {
		const scroller = scrollama()
		scroller
			.setup({ step: '.trigger', offset: 1 })
			.onStepEnter(response => {
				response.element.classList.add('xyz-in')
			})
	},
	setStartClippath: () => {
		const start = document.querySelectorAll('.js-clip-path-reference')

		start[0].addEventListener('load', () => {
			console.log('load');
			document.documentElement.style.setProperty('--start-clip-path-height', start[0].height + "px");
		})
	},
	initNavToggle: () => {

		const navigationEntries = document.querySelectorAll("#main-navigation a");
		const navToggle = document.querySelector(".nav-toggle");

		navToggle.addEventListener( 'click', () => {
			site.toggleNavigation()
		} )


		/**
		 * Bei Klick auf Navigationseinträge Menü schließen
		 */
		navigationEntries.forEach( (entry) => {
			entry.addEventListener( 'click', () => {
				site.toggleNavigation()
			} )
		})

	},

	toggleNavigation: function() {

		const navToggle = document.querySelector(".nav-toggle");
		const nav = document.querySelector("nav");
		const languageSwitch = document.querySelector(".language-switch")

		// Wir wollen die Navigation nur togglen, wenn wir mobil unterwegs sind
		if( window.getComputedStyle( navToggle ).display === 'none' ) {
			return
		}

		navToggle.classList.toggle('nav-toggle--opened')

		nav.classList.toggle('nav--visible')
		nav.classList.toggle('max-h-0')
		nav.classList.toggle('max-h-screen')
		nav.classList.toggle('opacity-0')
		nav.classList.toggle('opacity-100')

		languageSwitch.classList.toggle('max-h-0')
		languageSwitch.classList.toggle('max-h-screen')
		languageSwitch.classList.toggle('opacity-0')
		languageSwitch.classList.toggle('opacity-100')
		languageSwitch.classList.toggle('language-switch--visible')

		if( nav.classList.contains('nav--visible') ) {
			nav.classList.remove('hidden')
			languageSwitch.classList.remove('hidden')
		}

		else {

			// Wir warten auf die Transition
			setTimeout( function() {
				nav.classList.add('hidden')
				languageSwitch.classList.add('hidden')
			}, 500 )

		}

	}
}

document.addEventListener("DOMContentLoaded", function(event) {
	site.bootstrap()
});